export default "/images/vendor/flag-icon-css/flags/4x3/fk.svg?b2c8d118c250fb103ddb740b45252e18";